import React from 'react';

export const LocationProfileSkeleton: React.FC = () => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <div className="bg-white/70 backdrop-blur-xl rounded-3xl shadow-lg w-full max-w-4xl animate-pulse overflow-hidden">
        <div className="h-60 bg-gray-200" />
        <div className="p-6 space-y-4">
          <div className="h-6 bg-gray-200 rounded w-3/4" />
          <div className="h-4 bg-gray-200 rounded w-1/2" />
          <div className="h-32 bg-gray-200 rounded" />
        </div>
      </div>
    </div>
  );
};

export default LocationProfileSkeleton;
